// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"InfoIcon_infoIcon__2q0m3"};